import {
  addDoc,
  collection,
  getDocs,
  orderBy,
  query,
} from "firebase/firestore";
import { firestore } from "../firebase";
import { UserActivity, UserActivityDocument } from "../types/User";

export enum UserActivityEventType {
  USER_LOGIN = "USER_LOGIN",
  USER_REGISTERED = "USER_REGISTERED",
  ONBOARDING_COMPLETED = "ONBOARDING_COMPLETED",
  ONBOARDING_SKIPPED = "ONBOARDING_SKIPPED",
}

export interface ActivityEvent {
  eventType: UserActivityEventType;
  timestamp: number;
  context?: object;
}

export interface UserActivityEvent extends ActivityEvent {
  userId: string;
}

export function logAnonActivity(event: ActivityEvent): void {
  const userActivityCollection = collection(firestore, "userActivities");
  addDoc(userActivityCollection, {
    userId: "anonymous",
    eventType: event.eventType,
    timestamp: event.timestamp,
    context: event.context,
  });
}

export const logUserActivity = (event: UserActivityEvent): void => {
  const userActivityCollection = collection(firestore, "userActivities");
  addDoc(userActivityCollection, {
    userId: event.userId,
    eventType: event.eventType,
    timestamp: event.timestamp,
    context: event.context,
  });
};

export async function getUserActivities(): Promise<UserActivity[]> {
  const activitiesCollection = collection(firestore, "userActivities");
  const q = query(activitiesCollection, orderBy("timestamp", "desc"));
  const querySnapshot = await getDocs(q);

  const fetchedActivities: UserActivity[] = querySnapshot.docs.map((doc) => {
    const data = doc.data() as UserActivityDocument;
    return {
      id: doc.id,
      userId: data.userId,
      eventType: data.eventType,
      timestamp: data.timestamp,
      context: data.context,
    };
  });

  return fetchedActivities;
}
